import { render, staticRenderFns } from "./UploadAdvertisingImage.vue?vue&type=template&id=b8470df2&scoped=true"
import script from "./UploadAdvertisingImage.vue?vue&type=script&lang=js"
export * from "./UploadAdvertisingImage.vue?vue&type=script&lang=js"
import style0 from "./UploadAdvertisingImage.vue?vue&type=style&index=0&id=b8470df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8470df2",
  null
  
)

export default component.exports